import addStandard from "./addStandard/settings";
import projectOrder from "./projectOrder/settings";
import orderTask from "./orderTask/settings";
import check from "./check/settings";
export default {
  ...addStandard,
  ...projectOrder,
  ...orderTask,
  ...check,
};



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/indexZh.js